export default __webpack_public_path__ + "static/quote-3-dd556e17d15d5bdee96973de8a9f9a6a.mp3";